import { render, staticRenderFns } from "./CargosPendentesDistrito.vue?vue&type=template&id=579e9c93"
import script from "./CargosPendentesDistrito.vue?vue&type=script&lang=ts"
export * from "./CargosPendentesDistrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports